export enum SalesOrderActionEvent {
  FULLY_PAID
}
